

import layout from '@/components/layout'

export var routerList = [
    {
        path: '/',
        name: 'index',
        component: layout,
        meta: { title: '首页' },
        children: [
            {

                path: "",
                name: "首页",
                component: () => import('@/views/index/index'),
                meta: { title: '首页' },
            },
            {

                path: "home",
                name: "首页",
                component: () => import('@/views/index/index'),
                meta: { title: '首页' },
            },

        ]

    },
    {
        path: "/brandStyle",
        name: "热点资讯",
        component: layout,
        meta: { title: '品牌风采' },
        children: [
            {
                path: "",
                name: "热点资讯",
                component: () => import('@/views/brandStyle/index'),
                meta: { title: '品牌风采' },
            },
            {
                path: "detail",
                name: "详情",
                component: () => import('@/views/brandStyle/detail'),
                meta: { title: '详情' },
            }
        ]
    },
    {
        path: "/brandSummary",
        name: "品牌纪实",
        component: layout,
        meta: { title: '品牌纪实' },
        children: [
            {
                path: "",
                name: "品牌纪实",
                component: () => import('@/views/brandSummary/index'),
                meta: { title: '品牌纪实' },
            },
            {
                path: "detail",
                name: "品牌纪实详情",
                component: () => import('@/views/brandSummary/detail'),
                meta: { title: '品牌纪实详情' },
            }
        ]
    },
    {
        path: "/brandReport",
        name: "品牌报告",
        component: layout,
        meta: { title: '品牌报告' },
        children: [
            {
                path: "",
                name: "品牌报告",
                component: () => import('@/views/brandReport/index'),
                meta: { title: '品牌报告' },
            },
            {
                path: "detail",
                name: "品牌报告详情",
                component: () => import('@/views/brandReport/detail'),
                meta: { title: '品牌报告详情' },
            }
        ]
    },
    {
        path: "/brandAuthorize",
        name: "授权流程",
        component: layout,
        meta: { title: '授权流程' },
        children: [
            {
                path: "",
                name: "授权流程",
                component: () => import('@/views/brandAuthorize/index'),
                meta: { title: '授权流程' },
            },
            {
                path: "detail",
                name: "授权流程详情",
                component: () => import('@/views/brandAuthorize/detail'),
                meta: { title: '授权流程详情' },
            }
        ]
    },
    {
        path: "/brandStyle",
        name: "品牌风采",
        component: layout,
        meta: { title: '品牌风采' },
        children: [
            {
                path: "",
                name: "品牌风采",
                component: () => import('@/views/brandStyle/index'),
                meta: { title: '品牌风采' },
            },
            {
                path: "detail",
                name: "详情",
                component: () => import('@/views/brandStyle/detail'),
                meta: { title: '详情' },
            }
        ]
    },
    {
        path: "/brandMap",
        name: "品牌矩阵",
        component: layout,
        meta: { title: '品牌矩阵' },
        children: [
            {
                path: "",
                name: "品牌矩阵",
                component: () => import('@/views/brandMap/index'),
                meta: { title: '品牌矩阵' },
            },
        ]
    },
    {

        path: "/news",
        name: "热点资讯",
        component: layout,
        meta: { title: '热点资讯' },
        children: [
            {
                path: "",
                name: "热点资讯",
                component: () => import('@/views/news/index'),
                meta: { title: '热点资讯' },
            },
            {
                path: "detail",
                name: "详情",
                component: () => import('@/views/news/detail'),
                meta: { title: '详情' },
            }
        ]
    },
    {

        path: "/brandPublic",
        name: "区域公用品牌",
        component: layout,
        meta: { title: '区域公用品牌' },
        children: [
            {
                path: "",
                name: "区域公用品牌",
                component: () => import('@/views/brandPublic/index'),
                meta: { title: '区域公用品牌' },
            },
            {
                path: "detail",
                name: "故事详情",
                component: () => import('@/views/brandPublic/detail'),
                meta: { title: '故事详情' },
            }
        ]
    },
    {

        path: "/brandPublicAlone",
        name: "一镇一品",
        component: layout,
        meta: { title: '一镇一品' },
        children: [
            {
                path: "",
                name: "一镇一品",
                component: () => import('@/views/brandPublicAlone/index'),
                meta: { title: '一镇一品' },
            },
            {
                path: "detail",
                name: "详情",
                component: () => import('@/views/brandPublicAlone/detail'),
                meta: { title: '详情' },
            }
        ]
    },
    {
        path: "/directory",
        name: "授权名录",
        component: layout,
        meta: { title: '授权名录' },
        children: [
            {
                path: "",
                name: "授权名录",
                component: () => import('@/views/directory/index'),
                meta: { title: '授权名录' },
            },
            {
                path: "detail",
                name: "详情",
                component: () => import('@/views/directory/detail'),
                meta: { title: '详情' },
            }
        ]
    },
    {
        path: "/specialty",
        name: "海南特产馆",
        component: layout,
        meta: { title: '海南特产馆' },
        children: [
            {
                path: "",
                name: "海南特产馆",
                component: () => import('@/views/specialty/index'),
                meta: { title: '海南特产馆' },
            },
            {
                path: "detail",
                name: "详情",
                component: () => import('@/views/specialty/detail'),
                meta: { title: '详情' },
            }
        ]
    },
    {
        path: "/about",
        name: "关于平台",
        component: layout,
        meta: { title: '关于平台' },
        children: [
            {
                path: "",
                name: "关于平台",
                component: () => import('@/views/about/index'),
                meta: { title: '关于平台' },
            },
        ]
    },
    {
        path: "/brandRegion",
        name: "授权平台",
        component: layout,
        meta: { title: '授权平台' },
        children: [
            {
                path: "",
                name: "授权平台",
                component: () => import('@/views/brandRegion/index'),
                meta: { title: '授权平台' },
            },
        ]
    }

]




// WEBPACK FOOTER //
// ./src/router/router.js